// extracted by mini-css-extract-plugin
export default {"title":"DashboardCreated_title__Anj3W","link":"DashboardCreated_link__Fguo7","list":"DashboardCreated_list__csZ88"};